module.exports = __webpack_public_path__ + "images/ds-lda-bg-billing-extend-mobile.webp";